/**
 * @desc 一键出库
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(aono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/hotkeyDispatch/${aono}`, {
      method: "GET",

      ...options,
    }),
  );
}
